import * as React from "react";
import {
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  Paper,
} from "@material-ui/core";





export default function BasicTable({ transactionData}) {

  return (
    <TableContainer component={Paper} style={{marginTop:40}}>
      <Table sx={{ minWidth: 300 }} aria-label="simple table">
        <TableHead>
          <TableRow
            sx={{
              backgroundColor: "rgb(240, 249, 255)",
              boxShadow: "0px 0px 5px 2px rgba(0,0,0,0.1)",
              padding: "10px",
            }}
          >
            <TableCell sx={{ color: "white" }}>Lotno</TableCell>
            <TableCell sx={{ color: "white" }} align="center">
              Count
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {transactionData.map((row) => (
            <TableRow
              key={row.lotno}
              sx={{
                borderRadius: "px",
                boxShadow: "0px 0px 5px 2px rgba(0,0,0,0.1)",
              }}
            >
              <TableCell component="th" scope="row">
                {row.lotno}
              </TableCell>

              <TableCell align="center">{row.cnt}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
